import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewCommission from './new';
import EditCommission from './edit';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({commission, refetch}) => {
  const [showAddCommissionModal, setShowAddCommissionModal] = useState(false);
  const [showEditCommissionModal, setShowEditCommissionModal] = useState(false);
  const loc = useLocation();
  return (
    <NavbarContainer>
      {getLinks()}
    </NavbarContainer>
  )

  function getLinks() {
    if(loc.pathname === '/commissions-and-salespeople') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddCommissionModal(true)}
          >
            <Text>+ Add Commission</Text>
          </Pressable>
          {showAddCommissionModal &&
            <Modal
              showModal={showAddCommissionModal}
              setShowModal={setShowAddCommissionModal}
              modalType={'Add Commission'}
              commissionId={commission?.id}
            >
              <NewCommission
                setShowModal={setShowAddCommissionModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(loc.pathname === '/commissions/new') {
      return (
        <Link to={`/commissions`}>
          <Text>Commissions</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <BoldLinkText>{commission.name}</BoldLinkText>
          <LinkSpace />
          <Pressable
            onPress={() => {
              setShowEditCommissionModal(true)
            }}
          >
            <Text>
              Edit
            </Text>
          </Pressable>
          {showEditCommissionModal &&
            <Modal
              refetch={refetch}
              showModal={showEditCommissionModal}
              setShowModal={setShowEditCommissionModal}
              modalType={'Edit Commission'}
              objectName={commission.name}
            >
              <EditCommission
                setShowModal={setShowEditCommissionModal}
                refetch={refetch}
                commissionDetails={commission}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
